"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_assignedRepaymentTape = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const uinode_1 = require("../generated-repayment-tape/uinode");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
const createNewNode = ({ id, loanProductSlug, creditFacilitySlug, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = 'Assigned Repayment';
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            loanProductSlug,
            creditFacilitySlug,
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/**
 * Validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const { artifactSlug, creditFacilitySlug } = node.configuration;
    const errors = [];
    const edgeErrors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => {
            return uiNode.nodeType === 'file_generatedRepaymentTape';
        },
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        // This node currently only expected to be connected to BBR.
        // Can also have no outputs as well if we wanted
        minOutputs: 0,
        maxOutputs: 1,
    });
    edgeErrors.forEach((err) => errors.push(err));
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    // Already checked input length above with "checkEdges",
    // so can expect the length to be one here
    const generatedRepayment = inputNodes[0];
    if (uinode_1.file_generatedRepaymentTape.isNode(generatedRepayment)) {
        const generatedCf = generatedRepayment.configuration.creditFacilitySlug;
        // Recall that "credit facility" could be null for generated repayment
        // tape depending on the loan tape type for this loan product.
        // Just want to check if present, it's the same as assigned repayment.
        if (generatedCf) {
            if (generatedCf !== creditFacilitySlug) {
                errors.push(`Assigned Repayment Tape [${artifactSlug}] input must have same credit facility as generated repayment tape input node [${generatedRepayment.configuration.artifactSlug}]`);
            }
        }
    }
    else {
        errors.push(`Assigned Repayment Tape [${artifactSlug}] input must be a generated repayment tape, received [${generatedRepayment.metadata.tapeBuilderNodeType}]`);
    }
    return errors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_assignedRepaymentTape = {
    // What tape-builder node displays on UI creation menu.
    nodeTypeText: 'Assigned Repayment',
    // The node type, which is one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    badgeTexts: ['Assigned', 'Repayment'],
    // Creates sample configuration for this node.
    createNewNode,
    // Typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // Validate the configuration for the node for logical correctness
    hasValidConfig,
    validateIntermediateTape: () => [],
};
//# sourceMappingURL=uinode.js.map